import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import PropTypes from 'prop-types';
import cn from 'classnames';
import {nanoid} from 'nanoid';
import {useDispatch, useSelector} from 'react-redux';
import {
  InputCounter,
  InputCounterBtn,
  InputCounterField,
  PartialRefundContainer,
  PartialRefundItem,
  PartialRefundItemRside,
  PartialRefundItems,
  PartialRefundModifiersGroupTitle,
  PartialRefundSectionTitle
} from 'routes/App/Managers/RefundsCalculator/styles';
import CheckboxS2E from 'components/Checkbox';
import Body3 from 'components/typography/Body3';

import {
  RC_GENERATE_ORDER_REIMBURSEMENT,
  RC_HANDLE_CHECK,
  RC_QUANTITY_CHANGE
} from 'store/refundsCalculator/action';

const getPrice = (item) => {
  return (item.checked
    ? item.selected * item.subtotalAfterDiscount
    : item.quantity * item.subtotalAfterDiscount
  ).toFixed(2);
};

const PartialReimbursement = ({typeValue, setFaultError}) => {
  const dispatch = useDispatch();
  const {orderData, reimbursementResponsibility} = useSelector(
    (state) => state.refundsCalculator
  );

  const submitChanges = () => {
    if (reimbursementResponsibility !== -1) {
      dispatch(RC_GENERATE_ORDER_REIMBURSEMENT(typeValue));
    } else {
      setFaultError('Mandatory field');
    }
  };

  return (
    <PartialRefundContainer>
      <PartialRefundItems>
        {orderData?.items?.map((item, index) => (
          <>
            {item?.sectionName && (
              <PartialRefundSectionTitle>
                {item.sectionName}
              </PartialRefundSectionTitle>
            )}
            {item?.modifierGroupName && (
              <PartialRefundModifiersGroupTitle
                modifierLevel={item.path.length}
                className={cn({
                  modifier: item.path.length > 1
                })}
              >
                {item.modifierGroupName}
              </PartialRefundModifiersGroupTitle>
            )}
            <PartialRefundItem modifierLevel={item.path.length} key={nanoid()}>
              <FormControl
                className={cn({
                  modifier: item.path.length > 1
                })}
              >
                <CheckboxS2E
                  checked={item.checked}
                  onChange={(e) => {
                    dispatch(
                      RC_HANDLE_CHECK({index, checked: e.target.checked})
                    );
                    submitChanges();
                  }}
                  name='item'
                  label={
                    <div>
                      <div>{`${item.quantity}X ${item.name}`}</div>
                      {item?.specialRequest && (
                        <div className='itemSpecialNotes'>
                          ({item?.specialRequest})
                        </div>
                      )}
                    </div>
                  }
                />
              </FormControl>
              <PartialRefundItemRside>
                {item.checked && item.quantity > 1 && (
                  <InputCounter>
                    <InputCounterBtn
                      className={cn('btnPlus', {
                        disabled: item.selected === item.quantity
                      })}
                      onClick={() => {
                        dispatch(
                          RC_QUANTITY_CHANGE({
                            index,
                            value: item.selected + 1
                          })
                        );
                        submitChanges();
                      }}
                    />
                    <InputCounterField value={item.selected} readonly />
                    <InputCounterBtn
                      className={cn('btnMinus', {
                        disabled: item.selected === 1
                      })}
                      onClick={() => {
                        dispatch(
                          RC_QUANTITY_CHANGE({
                            index,
                            value: item.selected - 1
                          })
                        );
                        submitChanges();
                      }}
                    />
                  </InputCounter>
                )}
                <Body3 className='priceBlock'>${getPrice(item)}</Body3>
              </PartialRefundItemRside>
            </PartialRefundItem>
          </>
        ))}
      </PartialRefundItems>
    </PartialRefundContainer>
  );
};

PartialReimbursement.propTypes = {
  typeValue: PropTypes.number.isRequired,
  setFaultError: PropTypes.func
};

PartialReimbursement.defaultProps = {
  setFaultError: () => {}
};

export default PartialReimbursement;
